import { render, staticRenderFns } from "./TableComponent.vue?vue&type=template&id=471b08eb&scoped=true"
import script from "./TableComponent.vue?vue&type=script&lang=js"
export * from "./TableComponent.vue?vue&type=script&lang=js"
import style0 from "./TableComponent.vue?vue&type=style&index=0&id=471b08eb&prod&scoped=true&lang=scss"
import style1 from "./TableComponent.vue?vue&type=style&index=1&id=471b08eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471b08eb",
  null
  
)

export default component.exports